import React, { useEffect, useRef, useState } from "react";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useMail } from "contexts/mailContext/mailContext.js";
import AnimationContainer from "../AnimationContainer/AnimationContainer.js";
import useOnClickOutside from "hooks/useOnClickOutside.js";

const SearchAction = () => {
  const { setSearchParam, getSearchParam, getFilesLoading } = useMail();
  const [openInput, setOpenInput] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  // set search value on mount in case its already exist
  useEffect(() => {
    setOpenInput(getSearchParam().length > 0);
    setSearchValue(getSearchParam());
  }, []);

  // focus on input when opening it
  useEffect(() => {
    if (openInput) {
      inputRef.current.focus();
    }
  }, [openInput]);

  // submit search value and doing further request in setSearchParam function
  const handleSubmit = (e) => {
    e && e.preventDefault();
    if (searchValue.length > 0 && !getFilesLoading()) {
      setSearchParam(searchValue);
    }
  };

  // clear search value and close input on click on x icon
  const handleClear = () => {
    setSearchValue("");
    setSearchParam("");
    setOpenInput(false);
  };

  // open input on click on search icon
  const handleClickSearch = () => {
    if (searchValue.length > 0 && openInput) {
      handleSubmit();
    } else {
      setOpenInput((prev) => !prev);
    }
  };

  // handle input change
  const handleChange = (e) => {
    setSearchValue(e.target.value);
  };

  // ref for input to focus on it
  const inputRef = useRef(null);

  // ref for container to handle click outside and do either submit or close input
  const continerRef = useRef(null);
  useOnClickOutside(continerRef, () => {
    if (searchValue.length > 0) {
      handleSubmit();
    } else {
      setOpenInput(false);
    }
  });

  return (
    <div
      className={`search-action${openInput ? " open" : ""}`}
      ref={continerRef}
    >
      <AnimationContainer
        animationOn={openInput}
        animationClassName="width-animation"
      >
        <div className="search-files-form">
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              value={searchValue}
              onChange={handleChange}
              disabled={getFilesLoading()}
              ref={inputRef}
            />
          </form>
          {searchValue.length > 0 ? (
            <Icon name="x" gray clickable onClick={handleClear} />
          ) : null}
        </div>
      </AnimationContainer>
      <div className="icon-wrapper">
        <Tooltip tooltipTextKey="search-files-tooltip-text" top>
          <Icon
            name="search"
            gray
            blue={openInput && searchValue.length > 0}
            clickable
            onClick={handleClickSearch}
          />
        </Tooltip>
      </div>
    </div>
  );
};
export default SearchAction;
